<div class="card m-4" id="demo">
  <div class="card-body p-4 m-4 fs-5" style="font-family: Arial, Helvetica, sans-serif;">
    <div class="table-responsive">
      <table class="mb-4" style="width: 100%;">
        <tr>
          <td style="width: 50%;">
            <h1 class="fw-medium text-dark" style="font-family: Arial, Helvetica, sans-serif; text-transform: uppercase; margin: 0;">
              <strong>Insight360</strong>
            </h1>
          </td>
          <td style="width: 50%;text-align: center">
            <img alt="logo dark" class="card-logo card-logo-dark" height="50" src="assets/images/logo-light.svg">
            <img alt="logo light" class="card-logo card-logo-light" height="50" src="assets/images/logo-dark.svg">
          </td>
        </tr>
        <tr>
          <td class="fs-5" style="padding-top: 50px; font-weight: 700;">{{ company?.companyName }}</td>
          <td style="width: 50%;">
          </td>
        </tr>
        <tr>
          <td><div style="max-width: 350px">{{ company?.street }} {{ company?.houseNumber }}<br>
            {{ company?.postalCode }} {{ company?.city }}</div></td>
          <td style="width: 50%;">Tel: {{ configuration?.phoneNumber }}</td>
        </tr>
        <tr>
          <td style="width: 50%;">

          </td>
          <td style="width: 50%;">AT: {{ configuration?.openingHours }}</td>
        </tr>
        <tr>
          <td style="width: 50%;"></td>
          <td style="width: 50%;">Email ID: {{ configuration?.email }}</td>
        </tr>
        <tr>
          <td style="width: 50%; font-size: 18px; font-weight: 700;">
            {{ invoice?.contract?.renter?.firstName }} {{ invoice?.contract?.renter?.lastName }}
          </td>
          <td style="width: 50%;">{{ 'CONTRACTS.CONTRACT_NUMBER' | translate }} / {{ 'INVOICES.CUSTOMER_NUMBER' | translate }}</td>
        </tr>
        <tr>
          <td style="width: 50%;">
            {{ invoice?.contract?.renter?.street }} {{ invoice?.contract?.renter?.houseNumber }}<br>
            {{ invoice?.contract?.renter?.postalCode }} {{ invoice?.contract?.renter?.city }}
          </td>
          <td class="fs-4" style="width: 30%; font-weight: 700;">
            #{{ invoice?.contract?.contractNumber }} / {{ invoice?.contract?.renter?.idCardNumber }}
          </td>
        </tr>
        <tr>
          <td style="width: 50%;"></td>
          <td style="width: 30%;">
            <div>{{ 'INVOICES.PLEASE_MAKE_SURE' | translate }}</div>
          </td>
        </tr>
        <tr>
          <td></td>
          <td rowspan="3" style="width: 30%; text-align: left"></td>
        </tr>
      </table>
    </div>
    <div class="table-responsive">
      <table class="mt-5" style="width: 100%; margin-bottom: 20px">
        <tr>
          <td>
            <p style="margin: 0;">
              {{ getSalutationText() | translate }} {{ invoice?.contract?.renter | renterName }},
            </p>
          </td>
          <td></td>
        </tr>
        <tr>
          <td>
            <p style="margin: 0 0 10px 0;">{{ 'INVOICES.YOUR_BILLING' | translate }}</p>
          </td>
          <td rowspan="4" style="text-align: center" [innerHTML]="qrCodeSvg"></td>
        </tr>
        <tr>
          <td>
            <p style="margin: 0;">
              vom: {{ invoice?.invoiceDate | date:'MM.dd.yyyy' }} - {{ invoice?.dueDate | date:'MM.dd.yyyy' }}
            </p>
          </td>
          <td></td>
        </tr>
        <tr>
          <td>
            <p style="margin: 0 0 10px 0;">
              {{ 'INVOICES.INVOICE_NUMBER' | translate }}: #{{ invoice?.invoiceNumber }}
            </p>
          </td>
          <td></td>
        </tr>
      </table>
    </div>
    <div class="table-responsive">
      <table class="table-sm" style="width: 100%; margin-bottom: 18px; border: 1px solid black; border-collapse: collapse;">
        <tr style="border: 1px solid black; border-collapse: collapse;">
          <th style="text-align: center; font-weight: 600; padding: 2px 8px; border: 1px solid black; border-collapse: collapse;">#</th>
          <th style="text-align: center; font-weight: 600; padding: 2px 8px; border: 1px solid black; border-collapse: collapse;">{{ 'ACTIONS.COST-TYPES' | translate }}</th>
          <th style="text-align: center; font-weight: 600; padding: 2px 8px; border: 1px solid black; border-collapse: collapse;">{{ 'INVOICES.RATE_PRICE' | translate }}</th>
          <th style="text-align: center; font-weight: 600; padding: 2px 8px; border: 1px solid black; border-collapse: collapse;">{{ 'DASHBOARD.CNSP' | translate }}</th>
          <th style="text-align: center; font-weight: 600; padding: 2px 8px; border: 1px solid black; border-collapse: collapse;">{{ 'DASHBOARD.AMOUNT' | translate }}</th>
          <th style="text-align: center; font-weight: 600; padding: 2px 8px; border: 1px solid black; border-collapse: collapse;">{{ 'PROPERTY.TAX_RATE' | translate }}</th>
          <th style="text-align: center; font-weight: 600; padding: 2px 8px; border: 1px solid black; border-collapse: collapse;">{{ 'UTILITYRATES.TAXAMOUNT' | translate }}</th>
          <th style="text-align: center; font-weight: 600; padding: 2px 8px; border: 1px solid black; border-collapse: collapse;">{{ 'INVOICES.SUBTOTAL' | translate }}</th>
        </tr>
        @for (invoiceItem of invoice.items; track $index) {
          <tr style="border: 1px solid black; border-collapse: collapse;">
            <td style="text-align: center; padding: 5px 8px; border: 1px solid black; border-collapse: collapse" data-label="#"> {{ $index + 1 }} </td>
            <td style="text-align: center; padding: 5px 8px; border: 1px solid black; border-collapse: collapse;" data-label="Cost Type"> {{ invoiceItem?.labelText }} </td>
            <td style="text-align: center; padding: 5px 8px; border: 1px solid black; border-collapse: collapse;" data-label="Rate Price"> € {{ invoiceItem?.utilityRatePrice | number:'1.2-2' }} </td>
            <td style="text-align: center; padding: 5px 8px; border: 1px solid black; border-collapse: collapse;" data-label="Consumption"> {{ invoiceItem?.consumptionAmount }} </td>
            <td style="text-align: center; padding: 5px 8px; border: 1px solid black; border-collapse: collapse;" data-label="Amount"> € {{ (invoiceItem.invoiceItemAmount - invoiceItem.taxRateAmount) | number:'1.2-2' }} </td>
            <td style="text-align: center; padding: 5px 8px; border: 1px solid black; border-collapse: collapse;" data-label="Tax Rate"> {{ invoiceItem.taxRatePercent }} % </td>
            <td style="text-align: center; padding: 5px 8px; border: 1px solid black; border-collapse: collapse;" data-label="Tax Amount"> € {{ invoiceItem.taxRateAmount | number:'1.2-2' }} </td>
            <td style="text-align: center; padding: 5px 8px; border: 1px solid black; border-collapse: collapse;" data-label="Subtotal"> € {{ invoiceItem.invoiceItemAmount | number:'1.2-2' }} </td>
          </tr>
        }
      </table>
    </div>
    <div style="width: 100%; margin-bottom: 20px">
      <p class="text-end" style="font-weight: 700; margin-top: 0">{{ 'INVOICES.TOTAL_EURO' | translate }} (€): {{ invoice.totalInvoiceAmount | moneyFormat }}</p>
      <div style="margin-bottom: 10px">
        <p style="margin: 0 0 10px 0; font-size: 18px; font-weight: 700;">{{ bankName }}</p>
        <p style="margin: 0;">{{ 'APARTMENT.IBAN' | translate }}: {{ configuration?.bankIban }}</p>
        <p style="margin: 0;">SWIFT/BIC: {{ configuration?.bankBic }}</p>
        <p style="margin: 0 0 15px 0;">PLZ: {{ configuration?.postalCode }}</p>
      </div>
    </div>
    <div class="hstack gap-2 justify-content-end d-print-none mt-4">
      <a (click)="print()" class="btn btn-info">
        <i class="ri-printer-line align-bottom me-1"></i>
        <span>{{ 'TRANSACTION.PRINT' | translate }}</span>
      </a>
      <button (click)="download()" class="btn btn-primary">
        <i class="ri-download-2-line align-bottom me-1"></i>
        {{ 'INVOICES.DOWNLOAD' | translate }}
      </button>
    </div>
  </div>
</div>
